// @flow
import TrpcLibrary from 'digicel-kaizen-library/lib/tripica-library';
import React from 'react';
import { BulletPoint } from 'trpc-react-native-ui';
import formatDataVoiceSMSLabel from '../../../lib/DataVoiceSMSLabelFormatter';
import I18n from '../../../lib/i18n';
import { formatValue } from '../../../lib/usage-formatters';
import { getBoosterZone } from '../../payments/lib/PaymentLabelService';

const extractProductType = name => {
  const iddZone = getBoosterZone(name, 'ZONE');
  const roaZone = getBoosterZone(name, 'RDM');
  let labelZone = '';
  if (iddZone) labelZone = `_ZONE${iddZone}`;
  if (roaZone) labelZone = `_RDM${roaZone}`;

  if (name.includes('IDD') && name.includes('VOICE')) return 'IDD_VOICE_NEXT_PLAN';
  if (name.includes('IDD') && name.includes('ZONED')) return name;
  if (name.includes('IDD')) return name;
  if (name.includes('ROA') && name.includes('DATA')) return name;
  if (name.includes('DATA') && name.includes('EUROPE')) return `DATA_AND_EUROPE${labelZone}`;
  if (name.includes('SMS')) return `SMS${labelZone}`;
  if (name.includes('VOICE')) return `VOICE${labelZone}`;
  if (name.includes('DATA')) return `DATA${labelZone}`;

  return name;
};

const SubscriptionItem = (props: Props) => {
  if (props.type !== 'DEFAULT') {
    const formattedType = formatDataVoiceSMSLabel(props.type);
    const unit = TrpcLibrary.getUnitMapping(formattedType);
    const unitWhenZero = unit === 'DURATION' ? 'min' : null;
    const value = formatValue(props.value, unit, null, null, unitWhenZero);
    const translationKey = extractProductType(props.name || props.type);

    return <BulletPoint text={I18n.t(`catalog.${translationKey}_CREDIT_DETAIL_LIST`, { value })} />;
  } else if (props.name === 'PVOUCHER') {
    const voucher = props.voucher;
    const vTitle = I18n.t(
      `productOffering.PVOUCHER.productSpecification.characteristics.labelCode.${voucher.characteristics[0].labelCode}.label`
    );
    const shortDescription = I18n.t(
      `productOffering.PVOUCHER.productSpecification.characteristics.labelCode.${voucher.characteristics[0].labelCode}.shortDesc`
    );
    const voucherLabel = I18n.t(`VoucherDetails.nextPlanSubscriptionItem.label`) + vTitle + ' - ' + shortDescription;
    return <BulletPoint text={voucherLabel} />;
  }

  const value = formatValue(props.value, props.unit);
  return <BulletPoint text={props.name && I18n.t(`catalog.${props.name}`, { value })} />;
};

type Props = {
  type: string,
  name?: string,
  value?: string,
  unit?: string,
  voucher?: Object,
};

export default SubscriptionItem;
